import React, { useCallback, useState } from "react";
import { Description } from "@ddm-design-system/typography";
import { PrimaryButton } from "@ddm-design-system/button";
import { useDispatch } from "react-redux";
import SVGTap from "./assets/tap";
import { StyledProgressBar } from "./common.styles";
import { ECleaningUnitButtons, IControlUnit } from "../../../store/installation/types";
import { requestButtonPress } from "../../../store/installation/actions";
import useContent from "../../../hooks/useContent";

interface ICleanModeProps {
  controlUnit: IControlUnit;
}

const CleanMode: React.FC<ICleanModeProps> = ({ controlUnit }) => {
  const { managerAppControlUnit: content, managerAppCommon: common } = useContent();
  const dispatch = useDispatch();
  const [loadingButtonPress, setLoadingButtonPress] = useState(false);

  const handleContinue = useCallback(() => {
    setLoadingButtonPress(true);
    dispatch(
      requestButtonPress({
        button: ECleaningUnitButtons.CLEAN,
        controlUnitId: controlUnit.id
      })
    );
  }, [controlUnit.id, dispatch]);

  return (
    <div className="flex flex-col gap-xs items-center">
      <SVGTap detergent />
      <div className="flex flex-col gap-md items-center h-full">
        <Description>{content.manager_app_cu_step_clean_mode_desc}</Description>
        <StyledProgressBar colorType="detergent" value={controlUnit.progress} />
        <PrimaryButton
          disabled={controlUnit.progress < 100 || loadingButtonPress}
          onClick={handleContinue}
        >
          {common.common_continue}
        </PrimaryButton>
      </div>
    </div>
  );
};

export default CleanMode;
